import React, { Component } from 'react';

export class FourOhFour extends Component {
    render() {
        return (
            <div className="main-content">
                <div className="content-container">
                    <div className="center-content">
                        <h2>Page not found</h2>
                        <p>Sorry, we couldn't find the page you were looking for.</p>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/FourOhFour.js